<div class="content">
  <div class="title">
    <ng-container *ngIf="title; else defaultTitle">{{ title }}</ng-container>
  </div>
  <div *ngIf="description; else defaultDescription">{{ description }}</div>
  <ppl-input-container label="Verification Code"
                       i18n-label="@@Verification_Code"
                       [bold]="true"
                       [actionTemplate]="showResendCode ? resendCodeTemplate : null">
    <input pplInput
           autocomplete="off"
           placeholder="Enter code..."
           i18n-placeholder="@@Enter_code..."
           [value]="value"
           (input)="valueChange.emit($event.target.value)" />
    <ng-content select="extra-input-content"></ng-content>
  </ppl-input-container>
</div>

<ng-template #defaultTitle>
  <ng-container i18n="@@We've_sent_you_a_code...">We've sent you a code...</ng-container>
</ng-template>

<ng-template #defaultDescription>
  <div i18n="@@TwoFactorMethodSetupVerifyDefaultDescription">Enter the {{ TWO_FACTOR_CODE_LENGTH }}-digit verification code sent to:</div>
  <div class="value">{{ sentTo }}</div>
  <div i18n="@@It_may_take_several_seconds_or_minutes_to_arrive.">It may take several seconds or minutes to arrive.</div>
</ng-template>

<ng-template #resendCodeTemplate>
  <button pplLink
          type="button"
          class="re-send-button"
          (click)="resendCode.emit()"
          i18n="@@Re-send_code">Re-send code</button>
</ng-template>